import { Avatar, SxProps, Theme } from '@mui/material';
import React, { useMemo } from 'react';
import { User } from '@shared/models/user.model';
import { useUser } from '@client/hooks/use-user.hooks';

type UserAvatarProps = {
  user?: User;
  small?: boolean;
  size?: number;
  mt?: number;
  mr?: number;
};

const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  small,
  size,
  mt,
  mr,
}) => {
  const loggedInUser = useUser();
  const displayUser = user ?? loggedInUser;
  const isLoggedInUser = !!displayUser && displayUser.id === loggedInUser?.id;
  const diameter = size ?? (small ? 24 : 40);

  const styles = useMemo<SxProps<Theme>>(
    () => ({
      width: diameter,
      height: diameter,
      fontSize: diameter / 2,
      lineHeight: 'normal',
      fontWeight: 500,
      bgcolor: isLoggedInUser ? 'rgba(0,0,0,0.8)' : 'rgba(0,0,0,0.45)',
      color: 'rgba(255,255,255,0.8)',
      mt,
      mr,
    }),
    [diameter, mt, mr, isLoggedInUser],
  );

  if (!displayUser) return null;
  // Auth0's Gravatar fallback is a two-letter image, not a real profile photo.
  let picture = displayUser.picture;
  if (
    picture?.includes('gravatar.com/avatar/') ||
    picture?.includes('cdn.auth0.com/avatars/')
  ) {
    picture = '';
  }
  return (
    <Avatar src={picture} alt={displayUser.name} sx={styles}>
      {Array.from(
        (displayUser.name || displayUser.nickname).trim(),
      )[0]?.toLocaleUpperCase()}
    </Avatar>
  );
};

export default UserAvatar;
